import React from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"
const AdminDesaparecidosComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()



  return (<>

    <CRUD
      id="desaparecidos"

      isModal={false}
      cssClass="modalRight"
      recordButtonsPosition="start"
      filterOpen={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("Desaparecidos") ?? ""}
      icon={"fas fa-users"}
      getRecordsPath={`desaparecido/list`}
      getRecordsMethod="post"
      addEditRecordPath={`desaparecido/addEdit?currentUserId=${user.ID}`}
      deleteRecordPath="desaparecido/delete"
      autoOpenCreate={!!props.autoOpenCreate}
      prefillValues={props.prefillIdentifier ? { identificador: props.prefillIdentifier } : undefined}
      filterFields={[
        {
          name: "nombre",
          htmlType: "text",
          dbType: "string",
          title: t("Nombre") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
        {
          name: "apellido1",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 1") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

        {
          name: "apellido2",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 2") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

        {
          name: "alias",
          htmlType: "text",
          dbType: "string",
          title: "Alias",
          containerClass: "col-12 col-md-4",
          required: false,
        },

        {
          name: "cedula",
          htmlType: "text",
          dbType: "string",
          title: "cedula",
          containerClass: "col-12 col-md-4",
          required: false,
        },
        {
          name: "passport",
          htmlType: "text",
          dbType: "string",
          title: "Passport",
          containerClass: "col-12 col-md-4",
          required: false,
        },

      ]}
      fieldsList={[
        { name: "identificador", htmlType: "informe", title: t("Ver Informe") ?? "" },
        { name: "vinculo", htmlType: "text", title: t("Vinculo") ?? "" },
        { name: "identificador", htmlType: "cedula", title: t("Cédula") ?? "" },
        { name: "nombres", htmlType: "text", title: t("Nombre") ?? "", },
        { name: "primerApellido", htmlType: "text", title: t("Primer Apellido") ?? "", },
        { name: "segundoApellido", htmlType: "text", title: t("Segundo Apellido") ?? "", },
        { name: "alias", htmlType: "text", title: t("Alias") ?? "", },
        { name: "foto", htmlType: "picture", title: t("Foto") ?? "", },
        { name: "fotoCedula", htmlType: "picture", title: t("Foto Cédula") ?? "", },

      ]}
      fields={[
        { name: "separator", dbType: "string", title: t("Datos Personales") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "id", htmlType: "hidden", dbType: "string" },
        { name: "identificador", required: true, htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias", htmlType: "text", dbType: "string", title: t("Alias") ?? "", containerClass: "col-12 col-md-6" },

        { name: "foto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },

        { name: "notas", htmlType: "textarea", dbType: "string", title: t("Notas") ?? "", containerClass: "col-12 " },
        { name: "separator", dbType: "string", title: t("Fuentes") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "enlace1", htmlType: "text", dbType: "string", title: t("Enlace 1") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace2", htmlType: "text", dbType: "string", title: t("Enlace 2") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace3", htmlType: "text", dbType: "string", title: t("Enlace 3") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace4", htmlType: "text", dbType: "string", title: t("Enlace 4") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace5", htmlType: "text", dbType: "string", title: t("Enlace 5") ?? "", containerClass: "col-12 col-md-6" },

        { name: "separator", dbType: "string", title: t("Búsqueda") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "socialSearch", htmlType: "socialSearch", dbType: "string", title: t("Buscar en") ?? "", containerClass: "col-12" },

      ]}
    />
  </>
  )
}

export default AdminDesaparecidosComponent
